import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldType", "optionsWrapper"]

  toggle() {
    const isDropdown = this.fieldTypeTarget.value === "dropdown"
    this.optionsWrapperTarget.style.display = isDropdown ? "" : "none"
  }
}
